export default __webpack_public_path__ + "static/media/medico.8d4f7ff2.png";